
import React, { useState, useEffect } from 'react';
import '../styles/EmployeeSalaryBenefits.css';
import '../styles/SalaryGlobalUtility.css';

const EmployeeSalaryBenefits = () => {

    const [employees, setEmployees] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedId, setSelectedId] = useState("");
    const [docType, setDocType] = useState("Monthly Salary Slip");
    const [file, setFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const currentDate = new Date();
    const [month, setMonth] = useState(currentDate.toLocaleString('default', { month: 'long' }));
    const [year, setYear] = useState(currentDate.getFullYear());

    const months = [
        "January","February","March","April","May","June",
        "July","August","September","October","November","December"
    ];

    const years = [];
    for (let i = 2020; i <= currentDate.getFullYear() + 5; i++) {
        years.push(i);
    }

   useEffect(() => {
    fetch(
        "/gt-api/get_all_employees.php",
        {
            credentials: "include"
        }
    )
        .then(res => res.json())
        .then(data => {
            if (data.success) setEmployees(data.employees);
        })
        .catch(err => console.error("Error loading employees:", err));
}, []);                        

    const resetForm = () => {
        setSearchTerm("");
        setSelectedId("");
        setFile(null);
        setDocType("Monthly Salary Slip");
        setMonth(currentDate.toLocaleString('default', { month: 'long' }));
        setYear(currentDate.getFullYear());

        const fileInput = document.getElementById('salary-file');
        if (fileInput) fileInput.value = "";
    };

    const handleUpload = async () => {

        if (!selectedId || !file) {
            alert("Please select an employee and a file.");
            return;
        }

        setIsUploading(true);

        const formData = new FormData();
        formData.append("emp_id", selectedId);
        formData.append("doc_type", docType);
        formData.append("salary_file", file);
        formData.append("month", month);
        formData.append("year", year);

        try {

           const res = await fetch(
    "/gt-api/upload_salary_doc.php",
    {
        method: "POST",
        credentials: "include",
        body: formData
    }
);

            const result = await res.json();

            if (result.success) {
                alert(`SUCCESS: ${docType} has been dispatched.`);
                resetForm();
            } else {
                alert(result.message || "Upload failed.");
            }

        } catch (err) {
            console.error(err);
            alert("Dispatch failed. Please check your connection.");
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="management-salary-container animate-fade">
            <div className="module-glass-card">
                <h2 className="cyan-text">FINANCIAL DOCUMENT DISPATCH</h2>
                <div className="cyber-line"></div>

                <form className="upload-form">

                    <div className="form-row">
                        <div className="form-group">
                            <label>FIND RECIPIENT</label>
                          <div className="search-container-modern">
                                <input
                                    list="employee-list"
                                    className="cyber-input search-input"
                                    placeholder="Type Name or ID..."
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        const match = employees.find(emp =>
                                            `${emp.FirstName} ${emp.LastName} (${emp.EmpId})` === e.target.value
                                        );
                                        if (match) setSelectedId(match.id);
                                    }}
                                />
                                <datalist id="employee-list">
                                    {employees.map(emp => (
                                        <option key={emp.id} value={`${emp.FirstName} ${emp.LastName} (${emp.EmpId})`} />
                                    ))}
                                </datalist>
                                <span className="search-icon-hint">🔍</span>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>DOCUMENT TYPE</label>
                            <select className="cyber-input" value={docType} onChange={(e) => setDocType(e.target.value)}>
                                <option>MONTHLY SALARY SLIP</option>
                                <option value="Annual Form 16">ANNUAL FORM 16</option>
                                <option>APPRAISAL LETTER</option>
                                <option>FNF LETTER</option>
                                <option>OFFER LETTER</option>
                                <option>RELIEVING LETTER</option>
                                <option>EXPERIENCE LETTER</option>
                                <option>EMPLOYEMENT AGREEMENT</option>
                                <option>BANK ACCOUNT OPENING</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-row">

                        <div className="form-group">
                            <label>SELECT MONTH</label>
                            <select
                                className="cyber-input"
                                value={month}
                                onChange={(e) => setMonth(e.target.value)}
                            >
                                {months.map(m => (
                                    <option key={m}>{m}</option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>SELECT YEAR</label>
                            <select
                                className="cyber-input"
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                            >
                                {years.map(y => (
                                    <option key={y}>{y}</option>
                                ))}
                            </select>
                        </div>

                    </div>

                    <div className="file-upload-zone">
                        <input
                            type="file"
                            id="salary-file"
                            onChange={(e) => setFile(e.target.files[0])}
                            accept=".pdf"
                        />
                        <label htmlFor="salary-file" className="file-label">
                            {file ? (
                                <span className="file-ready-text">📄 {file.name} (READY)</span>
                            ) : (
                                "UPLOAD PDF DOCUMENT"
                            )}
                        </label>
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            className="btn-reset"
                            onClick={resetForm}
                            disabled={isUploading}
                        >
                            RESET FORM
                        </button>

                        <button
                            type="button"
                            className="btn-action approve"
                            onClick={handleUpload}
                            disabled={isUploading || !selectedId || !file}
                        >
                            {isUploading ? "DISPATCHING..." : "SEND TO DASHBOARD"}
                        </button>

                    </div>

                </form>
            </div>
        </div>
    );
};

export default EmployeeSalaryBenefits;







